module.exports = __webpack_public_path__ + "media/images/footer/fe-863d9334a046b243f5dac8ebd124f4f2.svg";